(function ($, undefined) {
    
    var isMobile = false;
    var win = $(window);
    var winWidth;
    var winHeight;
    var header;
    var toggleMenuBtn;
    var subNav;
    var subNavParent;
    var editableText;
    var dropdownCtn;
    var dropdownBtn;
    var dropdownlist;
    var dropdownlistItem;
    var contactFormBtn;
    var contactInput;
    var contactTextarea;
    var contactArea = '';
    var aProposScrollerBtn;
    var aProposTerritoiresToggle;
    var partenairesList;
    var fontSizeBtn;
    var minFS = 10;
    var maxFS = 14;
    var headerLink;

    var btnRecherchePannel;
    var recherchePannel;
    var mainContent;

    var newsListCtn;

    var recherchePannelForm;
    var recherchePannelFormInput;
    var recherchePannelFormItem;
    var recherchePannelRedirectBtn;
    var recherchePannelItemLink;
    var recherchePannelItemLinkPannel;
    var recherchePannelItemLinkHome;
    var recherchePannelItemPopup;
    var recherchePannelItemPopupClose;
    var recherchePannelSub;

    var rechercheFiltreListItemOpen;
    var rechercheContentFiltreListe;

    var regionUpdate;
    var locationUpdate;

    var chapterSelect;
    var chapterCapsuleBtn;

    var sendContactFormEmailClass = function () {
        var t = $(this);
        var validate = t.data('validate');
        var count = t.data('count');
        var form = t.closest($('.contactForm-Container'));

        var subject = $('.contactForm-subject', form).val();
		var subjectData = $('.js-contact-subject').find('.dropdown-select-input').attr('data-extra');
        var email = $('.contactForm-email', form).val();
		var directEmail = '';

		if (contactArea.length > 0 && subjectData) {
			if (subjectData.indexOf('{"') !== -1) {
				var obj = JSON.parse(subjectData);
				
				directEmail = obj[contactArea];
			} else if (subjectData.indexOf('@') !== -1) {
				directEmail = subjectData;
			}
		}

        var content = null;
        try {
            content = tinyMCE.get('contactForm-content', form).getContent();
        } catch (exception) {
            content = $('.contactForm-content', form).val();
        }

        var appendField = "";
        if ($('.fieldName1') !== null) {
            var total = 9;
            if (count) {
                total = count;
            }

            for (var i = 1; i < total; i++) {
                appendField += "&fieldName" + i + "=" +
                        encodeURIComponent($('.fieldName' + i, form).val());
                if ($('.field' + i, form).attr('type') == "checkbox") {
                    if ($('.field' + i, form).checked) {
                        appendField += "&field" + i + "=checked.";
                    } else {
                        appendField += "&field" + i + "=not checked.";
                    }
                } else {
                    appendField += "&field" + i + "=" +
                            encodeURIComponent($('.field' + i, form).val());
                }
            }
            appendField += "&count=" + total + "&directEmail=" + directEmail;
        }
        var captcha = $('.contactForm-captcha', form);
        if (captcha) {
            appendField += '&captcha=' + encodeURIComponent(captcha.val());
        }

        var validForm = true;
        var inputs = $('input', form);
        inputs.each(function () {
            var tInput = $(this);

            if ((tInput.attr('type') === "text" || tInput.attr('type') === "email" || tInput.attr('type') === "tel") && tInput.hasClass("requis") && tInput.val() === "") {
                validForm = false;
            }
        });
        var textareas = $('textarea', form);
        textareas.each(function () {
            var tTextareas = $(this);

            if (tTextareas.val() === "") {
                validForm = false;
            }
        });
        var selects = $('.dropdown-select', form);
        selects.each(function () {
            var tSelect = $(this);

            if (!tSelect.hasClass('has-char')) {
                validForm = false;
            }
        });

        if (!validForm && validate) {
            //popErrorDisplayOnSite('error.message.emptyForm');
            $('.contact-form-form-error', form).slideDown(200);

        } else {
            $('.contact-form-form-error', form).slideUp(200);
            ajax(actionPath + "contactUs?subject=" + encodeURIComponent(subject) +
                    "&email=" + encodeURIComponent(email) +
                    "&content=" + encodeURIComponent(content) +
                    appendField, sendContactFormEmailConfirmClass(form));
        }
    };

    var sendContactFormEmailConfirmClass = function (form) {
        var bigCtn = form.closest('.contactForm-Container-big');

        $('.contactForm-Container', bigCtn).slideUp(1000, function () {
            $('.contactForm-sent', bigCtn).slideDown(300);
        });
    };

    var toggleScroll = function () {
        var diff;

        if ($('html').hasClass('no-scroll')) {
            $('html').removeClass('no-scroll');
            diff = 0;
        } else {
            var w1 = win.width();
            $('html').addClass('no-scroll');
            var w2 = win.width();
            diff = w2 - w1;
        }

        changeScrollDiff(diff);
    };

    var changeScrollDiff = function (diff) {
        $('.js-scroll-padding').css('padding-right', diff + 'px');
        $('.js-scroll-right').css('right', diff + 'px');
    };

    var onClickMenuToggle = function () {
        if (!!header.hasClass('menu-open')) {
            var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
            header.removeClass('menu-open');

            header.on(transitionEnd, function (e) {
                $('html').removeClass('no-scroll');
                changeScrollDiff(0);
                $(this).off(e);
            });
        } else {
            header.addClass('menu-open');
            toggleScroll();
        }
    };

    var moveEditableText = function () {
        var text = $('.editable-text-ctn');

        text.each(function () {
            var t = $(this);
            var ctn = t.parent('.js-editable-container');
            var pos;
            var receiver;

            if (t.attr('data-position') !== 0) {
                pos = t.attr('data-position');
            } else {
                pos = 1;
            }

            if ($('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length !== 0) {
                receiver = $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn);
            } else {
                receiver = $('.js-editable-receiver', ctn);
            }

            if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 &&
                    $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length === 0 &&
                    t.attr('data-position') !== '') {
                t.remove();
            } else if (ctn.length !== 0 && receiver.length !== 0) {
                t.detach().appendTo(receiver);
            }
        });
    };

    var addEditableTextClass = function () {
        $('.componentContainerDiv').addClass('js-editable-container');

        editableText.each(function () {
            var t = $(this);
            var parent = t.parent();

            parent.addClass('editable-text-ctn');
        });
    };

    var addEditableTextPosition = function () {
        $('.js-editable-container').each(function () {
            var index = 1;
            var t = $(this);

            $('.editable-text-ctn', t).each(function () {
                var t = $(this);

                t.attr('data-position', index);

                index++;
            });
        });
    };

    var updateSubNavPosition = function () {
        subNav.each(function () {
            var t = $(this);
            var tOffset = t.offset().left;
            var tWidth = t.width();
            var totalOffset = tOffset + tWidth;

            if (totalOffset >= winWidth) {
                var newLeft = winWidth - totalOffset;
                t.css('left', newLeft);
            }
        });
    };

    var initSubNavMobile = function () {
        $('.site-nav-item', header).removeClass('show-subnav');

        if (win.width() < 1024) {
            subNav.slideUp(0);
        } else {
            subNav.slideDown(0);
        }
    };

    var menuSubNavParentClick = function (e) {
        if (win.width() < 1024) {
            e.preventDefault();
        }
        var t = $(this);
        var parent = t.parent('.site-nav-item');

        if (!!parent.hasClass('show-subnav')) {
            parent.removeClass('show-subnav');
            $('.site-nav-sub', parent).slideUp(300);
        } else {
            parent.addClass('show-subnav');
            $('.site-nav-sub', parent).slideDown(300);
        }
    };

    var autoScreenHeight = function () {
        var winH = win.height();
        var items = $('.js-auto-screen-height');

        if (window.location.href.indexOf("organisme") > -1) {
            $('.organisme-intro-content-map').addClass('Organisme-Map-Max-Height');
        }

        items.each(function () {
            var t = $(this);
            var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
            var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
            var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
            var offsetHeight = 0;

            $.each(offset, function (i) {
                offsetHeight += $(offset[i]).outerHeight();

            });

            var newHeight = (winH * factor) - offsetHeight;

            t.css(attr, newHeight);
        });
    };

    var addExternalLinkTarget = function () {
        $.expr[':'].external = function (obj) {
            return !obj.href.match(/^mailto\:/) &&
                    (obj.hostname != location.hostname) &&
                    !obj.href.match(/^javascript\:/) &&
                    !obj.href.match(/^$/) &&
                    !obj.href.match(/\.pdf$/);
        };

        $('a:external').attr('target', '_blank');
    };

    var initContactDD = function () {
        dropdownlist.slideUp(0);
    };

    var formFieldFocus = function () {
        var t = $(this);
        var parent = t.closest('.contact-form-form-item');

        parent.addClass('has-char');
    };

    var formFieldBlur = function () {
        var t = $(this);
        var parent = t.closest('.contact-form-form-item');

        if (t.val() === '') {
            parent.removeClass('has-char');
        }
    };

    var aProposScrollTo = function () {
        var t = $(this);
        var target = $(t.attr('data-rel'));

        win.scrollTo(target, 300);
    };

    var aProposCheckScroll = function () {
        var itemsList = aProposScrollerBtn;
        var scroll = win.scrollTop() + (win.height() / 2);

        for (var i = 0; i <= itemsList.length - 1; i++) {
            var item = $($(itemsList[i]).attr('data-rel'));
            var itemTop = item.offset().top;
            var itemBottom = itemTop + item.height();
            aProposScrollerBtn.removeClass('selected');

            if (scroll >= itemTop && scroll < itemBottom) {
                $('.a-propos-scroller-btn[data-rel=".' + item.attr('class') + '"]').addClass('selected');
                break;
            }
        }
    };

    var aProposTerritoiresToggleClick = function () {
        var t = $(this);

        updateLabelLangs('a-propos-territoires-toggle', t.is(':checked').toString(), 'fr, en', function () {}, true);
    };

    var initSlick = function () {
        var defaults = {
            prevArrow: '.js-slick-prev',
            nextArrow: '.js-slick-next',
            arrows: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: '.js-slick-slide',
            dots: false,
            asNavFor: '',
            draggable: false,
            autoplay: false,
            autoplaySpeed: 3000,
            fade: false,
            cssEase: 'ease'
        };

        $('.js-slick').each(function () {
            var t = $(this);
            var options = {
                prevArrow: t.data('slickPrevArrow'),
                nextArrow: t.data('slickNextArrow'),
                arrows: t.data('slickArrows'),
                infinite: t.data('slickInfinite'),
                speed: t.data('slickSpeed'),
                slidesToShow: t.data('slickSlidesToShow'),
                slidesToScroll: t.data('slickSlidesToShow'),
                slide: t.data('slickSlide'),
                dots: t.data('slickDots'),
                asNavFor: t.data('slickAsNavFor'),
                draggable: t.data('slickDraggable'),
                autoplay: t.data('slickAutoplay'),
                autoplaySpeed: t.data('slickAutoplaySpeed'),
                fade: t.data('slickFade'),
                cssEase: t.data('slickCssEase'),
                adaptiveHeight: t.data('slickAdaptiveHeight')
            };

            var settings = $.extend({}, defaults, options);

            t.slick({
                prevArrow: settings.prevArrow,
                nextArrow: settings.nextArrow,
                arrows: settings.arrows,
                infinite: settings.infinite,
                speed: settings.speed,
                slidesToShow: settings.slidesToShow,
                slidesToScroll: settings.slidesToScroll,
                slide: settings.slide,
                dots: settings.dots,
                asNavFor: settings.asNavFor,
                draggable: settings.draggable,
                autoplay: settings.autoplay,
                autoplaySpeed: settings.autoplaySpeed,
                fade: settings.fade,
                cssEase: settings.cssEase,
                adaptiveHeight: settings.adaptiveHeight
            });
        });

        $('.slide-title').each(function () {
            var $slide = $(this).parent();
            if ($slide.attr('aria-describedby') != undefined) { // ignore extra/cloned slides
                $(this).attr('id', $slide.attr('aria-describedby'));
            }
        });
    };

    var togglePartenairesSlick = function () {
        //if (winWidth < 600 && !partenairesList.hasClass('slick-initiated')) {
        partenairesList.slick({
            slide: '.partenaires-item-big-ctn',
            arrows: false,
            dots: false,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                }, {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }]
        });
        /*} else if (winWidth >= 600 && partenairesList.hasClass('slick-initiated')) {
         partenairesList.unslick();
         }*/
    };

    var initFontSize = function () {
        var el = $('html');

        if (getCookie('fontCookie') !== '') {
            el.css('font-size', getCookie('fontCookie') + 'px');
        }
    };

    var setFont = function () {
        var down = $(this).hasClass('shrink') ? true : false;
        var currSize;
        var newSize;

        //getCookie('fontCookie');

        var el = $('html');

        if (getCookie('fontCookie') === '') {
            currSize = parseFloat(el.css('font-size'));
        } else {
            currSize = parseFloat(getCookie('fontCookie'));
        }

        if (currSize > minFS && down) {
            newSize = (currSize - 1) < minFS ? minFS : (currSize - 1);
        } else if (!down && currSize < maxFS) {
            newSize = (currSize + 1) > maxFS ? maxFS : (currSize + 1);
        } else {
            /*Si pas de changement car une des deux conditions est ex�d�e.*/
            newSize = currSize;
        }


        el.css('font-size', newSize + "px");

        updateFSButtonState();
        createCookie('fontCookie', newSize, 10000000);
    };

    var createCookie = function (name, value, days) {
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };

    var getCookie = function (c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                var c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) {
                    c_end = document.cookie.length;
                }
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    };

    var updateFSButtonState = function () {
        var currFS = parseFloat($('html').css('font-size'));

        if (currFS <= minFS) {
            $('.site-header-meta-font-size-btn.shrink').addClass('disabled');
        } else if (currFS >= maxFS) {
            $('.site-header-meta-font-size-btn.big').addClass('disabled');
        } else {
            $('.site-header-meta-font-size-btn').removeClass('disabled');
        }
    };

    var toggleRecherchePannel = function () {
        var pannelW = recherchePannel.width();
        var siteW = 1320;
        var dur = 400;
        var sideW = winWidth > siteW ? (winWidth - siteW) / 2 : 0;
        var offset = pannelW - sideW;
        var offsetDelay = dur * (sideW / pannelW);

        if ($('body').hasClass('recherche-open')) {
            closePannel(dur);

        } else {
            $('body').addClass('recherche-open');
            win.scrollTo(0, dur);

            recherchePannel.animate({left: "-" + pannelW}, dur, "linear", function () {
                $('html').addClass('no-scroll');
                win.scrollTo(0, 0);
                $(document).on('click', outsideClickPannel);
            });

            if (winWidth < (siteW + pannelW * 2)) {
                setTimeout(function () {
                    mainContent.animate({left: "-" + offset}, dur - offsetDelay, "linear");
                }, offsetDelay);
            }
        }
    };

    var outsideClickPannel = function (event) {
        if (!$(event.target).closest('.recherche-side-pannel').length) {
            closePannel(400);
        }
    };

    var closePannel = function (dur) {
        $('body').removeClass('recherche-open');

        recherchePannel.animate({left: "1px"}, dur, "linear", function () {
            $('html').removeClass('no-scroll');
            $(document).off('click', outsideClickPannel);
        });

        mainContent.animate({left: "0px"}, dur, "linear");
    };

    var checkPannelPos = function () {
        var pannelW = recherchePannel.width();
        var siteW = 1320;
        var sideW = winWidth > siteW ? (winWidth - siteW) / 2 : 0;
        var offset = pannelW - sideW;

        recherchePannel.css('left', -pannelW);

        if (winWidth < (siteW + pannelW * 2)) {
            mainContent.css('left', -offset);
        }
    };

    var initNewsScroll = function () {
        newsListCtn.jscroll({
            autoTrigger: false,
            nextSelector: '.js-news-list-link',
            contentSelector: '.js-news-list',
            loadingHtml: '<div class="nouvelle-list-loading">...</div>'
        });
    };

    var rechercheFiltreClick = function () {
        var t = $(this);
        var fx = t.hasClass('active') ? 'removeClass' : 'addClass';
        var ctn = t.closest('.recherche-pannel-form');

        t[fx]('active');
        rechercheUpdateLink(ctn);
    };

    var rechercheInputCPannelhange = function () {
        rechercheUpdateLink($(this).closest('.recherche-pannel-form'));
    };

    var rechercheUpdateLink = function (ctn) {
        var input = $('.recherche-pannel-input', ctn);
        var items = $('.recherche-item-link.active', ctn);
        var handle = ctn.attr('data-url');
        
        if (!handle) {
            return false;
        }
        
        var url = handle;
        if (items.length !== 0 || input.val() !== '') {
            url += '?';
        }

        if (input.val() !== '') {
            url += 'val=';
            url += input.val();
        }

        if (items.length !== 0 && input.val() !== '') {
            url += '&';
        }

        if (items.length !== 0) {
            url += 'item=';

            for (var i = 0; i < items.length; i++) {
                url += items.eq(i).attr('data-category');

                if (i !== items.length - 1) {
                    url += ';';
                }
            }
        }

        $('.recherche-pannel-btn', ctn).attr('href', url);
    };

    var checkMobile = function () {
        if ($('#mobile-check').css('display') === 'none') {
            isMobile = true;
            $('html').addClass('mobile');
        } else {
            isMobile = false;
            $('html').removeClass('mobile');
        }
    };
    
    var dropdownDeleteDouble = function () {
        dropdownCtn.each(function () {
            var duplicata = [];

            $('.dropdown-select-pannel-item', $(this)).each(function () {
                var t = $(this);
                var value = t.attr('data-value');

                if (duplicata[value]) {
                    t.remove();
                } else {
                    duplicata[value] = true;
                }
            });
        });
    };

    var dropdownOrderList = function () {
        var list = $('.dropdown-select.order');
        var items = $('.dropdown-select-pannel-item', list);
        var targetList = $('.dropdown-select-pannel-inner', list);
        var sortList = {};
        var sortedList = [];

        items.each(function () {
            var t = $(this);
            var handle = t.attr('data-value');

            sortList[handle] = t.clone();

            t.remove();
        });

        for (var i in sortList) {
            sortedList.push([i, sortList[i]]);
        }

        sortedList.sort(function (a, b) {
            a = a[1];
            b = b[1];

            return a < b ? -1 : (a > b ? 1 : 0);
        });


        for (var k in sortList) {
            targetList.append(sortList[k]);
        }
    };

    var recherchePannelRedirectInput = function (ch) {
        if (ch === 13 || ch === 10) {
            var focusInput;
            var focusSuggest = $('.js-suggest-item-link.key-selected');
            if (focusSuggest.length !== 0) {
                var t = focusSuggest;
                var ctn = t.closest('.recherche-pannel-index-mot-content');

                if (ctn.length !== 0) {
                    var inputLocation = $('.recherche-pannel-index-mot-label-input.location-geo', ctn);
                    //var valLocation = removeDiacritics(inputLocation.val().split(',')[0]);
                    var valLocation = inputLocation.val().split(',')[0];
                    var url = focusSuggest.attr('href');
                    var placeLat = '';
                    var placeLng = '';
                    var geocoder = new google.maps.Geocoder();

                    if ($(".localize-popup-lat", ctn).val() !== '' && inputLocation.val().length !== 0) {
                        placeLat = $(".localize-popup-lat", ctn).val();
                        placeLng = $(".localize-popup-lng", ctn).val();

                        url += '&place=' + inputLocation.val();
                        url += '&lat=' + placeLat;
                        url += '&lng=' + placeLng;
                        url += '&sort=proximity';
                        if (valLocation.length !== 0) {
                            saveSessionVariable('location', inputLocation.val(), function () {
                                    saveSessionVariable('lat', placeLat, function () {
                                        saveSessionVariable('lng', placeLng, function () {
                                            location.href = url;
                                        });
                                    });
                            });
                        }
                    } else if (valLocation.length !== 0) {
                        geocoder.geocode({'address': inputLocation.val()}, function (results, status) {
                            if (status == google.maps.GeocoderStatus.OK) {
                                placeLat = results[0].geometry.location.lat();
                                placeLng = results[0].geometry.location.lng();
                            } else {
                                alert("Geocode was not successful for the following reason: " + status);
                            }

                            url += '&place=' + inputLocation.val();
                            url += '&lat=' + placeLat;
                            url += '&lng=' + placeLng;
                            url += '&sort=proximity';
                            saveSessionVariable('location', valLocation, function () {
                                    saveSessionVariable('lat', placeLat, function () {
                                        saveSessionVariable('lng', placeLng, function () {
                                            location.href = url;
                                        });
                                    });
                            });
                        });
                    } else {
                        location.href = focusSuggest.attr('href');
                    }

                    return false;
                } else {
                    location.href = focusSuggest.attr('href');
                }
            } else {
                recherchePannelFormInput.each(function () {
                    var t = $(this);

                    if (t.is(':focus')) {
                        focusInput = t;

                        var ctn = t.closest('.recherche-pannel-form');
                        var btn = $('.recherche-pannel-btn', ctn);

                        if (t.is(':focus')) {
                            recherchePannelRedirectGeneral(ctn, btn);
                        }

                        return false;
                    }
                });
            }
        }
    };

    var recherchePannelRedirect = function () {
        var t = $(this);
        var ctn = t.closest('.recherche-pannel-form');

        recherchePannelRedirectGeneral(ctn, t);
    };

    var recherchePannelRedirectGeneral = function (ctn, btn) {
        var pathname = btn.attr('data-url');
        var inputVal = $('.recherche-pannel-input', ctn).val();
        var url = location.origin + '/';

        var inputLocation = $('.recherche-pannel-index-mot-label-input', ctn);

        if ($('html').attr('lang') === 'en') {
            url += 'en/';
        }

        url += pathname;

        if (inputVal !== '') {
            url += '?q=' + encodeURIComponent(inputVal);
        }
        if (inputLocation.val()) {
           /// window.alert(inputLocation.val().split(',')[0]);
           // var valLocation = removeDiacritics(inputLocation.val().split(',')[0]);
            var valLocation = inputLocation.val().split(',')[0];
           // window.alert(valLocation);
            if($(".localize-popup-lat", ctn).val() !== '' && valLocation.length !== 0){  
                var placeLat = $(".localize-popup-lat", ctn).val();
                var placeLng = $(".localize-popup-lng", ctn).val();
                if (inputVal == '') {
                    url += '?';
                } else {
                    url += '&';
                }

                url += 'place=' + inputLocation.val();
                url += '&lat=' + placeLat;
                url += '&lng=' + placeLng;

                returnSessionVariable('field11',function (result) {
                    url += '&field11=' + decodeURIComponent(result);
                    
                 });

                 returnSessionVariable('field12',function (result) {
                    url += '&field12=' + decodeURIComponent(result);
                    
                 });

                 returnSessionVariable('field13',function (result) {
                    url += '&field13=' + decodeURIComponent(result);
                    
                 });

                 returnSessionVariable('serve',function (result) {
                    url += '&serve=' + decodeURIComponent(result);
                    
                 });

                url += '&sort=proximity';
                if (inputVal.length !== 0 || valLocation.length !== 0) {
                    saveSessionVariable('location', inputLocation.val(), function () {
                        saveSessionVariable('place', inputLocation.val(), function () {
                            saveSessionVariable('lat', placeLat, function () {
                                saveSessionVariable('lng', placeLng, function () {
                                    location.href = url;
                                });
                            });

                        });      
                    });
                }
            } else if (valLocation.length !== 0) {
                if (inputVal == '') {
                    url += '?';
                } else {
                    url += '&';
                }

                url += 'place=' + inputLocation.val();

                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({'address': inputLocation.val()}, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var placeLat = results[0].geometry.location.lat();
                        var placeLng = results[0].geometry.location.lng();

                        url += '&lat=' + placeLat;
                        url += '&lng=' + placeLng;

                        //////////////////////////
                        var GLLMontreal = new google.maps.LatLng(45.5, -73.6833334);
                        var GAutocompleteService = new google.maps.places.AutocompleteService();
                        var dummy = document.createElement('DIV');
                        var GPlacesService = new google.maps.places.PlacesService(
                            new google.maps.Map(dummy, {center: GLLMontreal})
                        );
                        var sessionToken = new google.maps.places.AutocompleteSessionToken();
                        var request = {
                            input: inputLocation.val(),
                            sessionToken: sessionToken,
                            location: GLLMontreal,
                            radius: 200000 //meters
                        };
                        GAutocompleteService.getPlacePredictions(
                            request, 
                            function(predictions, status) {
                                if (status == google.maps.places.PlacesServiceStatus.OK && predictions) {
                                    GPlacesService.getDetails(
                                        {
                                            placeId: predictions[0].place_id,
                                            fields: ['address_component', 'geometry', 'name']
                                        },
                                        function(place, status) {
                                            if (status == google.maps.places.PlacesServiceStatus.OK) {
                                                saveSessionVariable('serve', serveValue);
                                                url = updateQueryStringParameter(url, 'serve', serveValue);
            
            
                                                window.processInfo(place, t.closest('.ref-ctn'));
                                                // Final process is geolocalizeMeSave() in geolocalisation.js
                                            } else {
                                                // Error from google service, proceed nevertheless
                                                _start();
                                            }
                                        }
                                    );
                                } else {
                                    // Error from google service, proceed nevertheless
                                    _start();
                                }
                            }
                        );


                        returnSessionVariable('field11',function (result) {
                            url += '&field11=' + decodeURIComponent(result);
                            
                         });
        
                         returnSessionVariable('field12',function (result) {
                            url += '&field12=' + decodeURIComponent(result);
                            
                         });
        
                         returnSessionVariable('field13',function (result) {
                            url += '&field13=' + decodeURIComponent(result);
                            
                         });

                        ///////////////////////
                        returnSessionVariable('serve',function (result) {
                            url += '&serve=' + decodeURIComponent(result);
                            
                         });
        
                        //url += '&serve=1';
                        url += '&sort=proximity';
                    } else {
                        alert("Geocode was not successful for the following reason: " + status);
                    }

                    if (inputVal.length !== 0 || valLocation.length !== 0) {
                        saveSessionVariable('location', inputLocation.val(), function () {
                                saveSessionVariable('lat', placeLat, function () {
                                    saveSessionVariable('lng', placeLng, function () {
                                        location.href = url;
                                    });
                                });
                        });
                    }
                });
            } else {
                if(url.indexOf("?") != -1){
                    url += '&sort=name';                    
                } else {
                    url += '?sort=name';
                }
                location.href = url;
            }
        } else {
            saveSessionVariable('location', '');
            saveSessionVariable('field11', '');
            saveSessionVariable('field12', '');
            saveSessionVariable('field13', '');
            saveSessionVariable('lat', '');
            saveSessionVariable('lng', '');
            saveSessionVariable('popupFilled', '');
            saveSessionVariable('serve', '');
            if(url.indexOf("?") != -1){
                url += '&sort=name';                    
            } else {
                url += '?sort=name';
            }
            location.href = url;
        }
    };

    var recherchePannelItemLinkClick = function () {
        var t = $(this);
        var ctn = t.closest('.recherche-pannel-item');
        var btn = $('.recherche-pannel-item-link', ctn);
        var link = $('.btn-pannel-popup-btn:eq(1)', ctn);
        resetRechercheGeolocReset();

        if (ctn.hasClass('open')) {
            ctn.removeClass('open');
            btn.focus();
        } else {
            ctn.addClass('open');
            link.focus();
        }
    };

    var resetRechercheGeolocReset = function () {
		var t = $(this);
		var ctn = t.closest('.recherche-pannel-index-mot-content');
		
		$('.recherche-pannel-index-mot-label-input.location-geo').val('');
		$('.recherche-pannel-index-mot-label-input.location').val('');
        $('.localize-popup-location').val('');
        $('.localize-popup-lat').val('');
        $('.localize-popup-lng').val('');
        $('.localize-popup-field11').val('');
        $('.localize-popup-field12').val('');
        $('.localize-popup-field13').val('');
        $('.localize-popup-serve').val('');
        
        var count = 8;
        saveSessionVariable('field11', '', _complete);
        saveSessionVariable('field12', '', _complete);
        saveSessionVariable('field13', '', _complete);
        saveSessionVariable('field16', '', _complete);
        saveSessionVariable('location', '', _complete);
        saveSessionVariable('serve', '', _complete);
        saveSessionVariable('lat', '', _complete);
        saveSessionVariable('lng', '', _complete);

        function _complete() {
        	if (--count <= 0) {
	    	    $(rechercheGeolocResetBtn).hide();
	    		$('.locality').text('-');
	    		$('.recherche-pannel-categorie-liste').attr('data-start-search', 'false');
        	}
        }
	};

    var recherchePannelItemPopupCloseClick = function () {
        var t = $(this);
        var ctn = t.closest('.recherche-pannel-item');
        var btn = $('.recherche-pannel-item-link', ctn);

        ctn.removeClass('open');
        $('.recherche-pannel-item-popup-content', ctn).removeClass('show');
        btn.focus();
    };

    var recherchePannelItemLinkPannelClick = function () {
        if (isMobile) {
            var target = $('.recherche-pannel-top').height() + parseInt($('.recherche-pannel-top').css('padding-top'));

            $('.recherche-side-pannel-content-big').animate({scrollTop: target}, 200);
        }
    };

    var recherchePannelItemLinkHomeClick = function () {
        if (isMobile) {
            var target = $('.index-recherche .recherche-pannel-categorie').offset().top;

            $('html, body').animate({scrollTop: target}, 200);
        }
    };

    var recherchePannelSubClick = function () {
        var t = $(this);
        var mainCtn = t.closest(".recherche-pannel-categorie-liste");
        var startSearch = mainCtn.attr("data-start-search");
        var catId = t.data('cat-id');
        var subCatHandle = t.data('sub-cat');
        var url = t.data('url');
        var ctn = t.closest('.recherche-pannel-item-popup-content');
        var btn = $('.recherche-pannel-btn', ctn);
        var lat = mainCtn.attr("data-lat");
        var lng = mainCtn.attr("data-lng");

         if (startSearch !== null && startSearch === 'true' && $('.recherche-pannel-item-popup-content-location', ctn).length !== 0) {
            btn.attr('data-cat-id', catId).attr('data-sub-cat', subCatHandle).attr('data-url', url);
            $('.recherche-pannel-item-popup-content-location', ctn).find(".recherche-pannel-btn").trigger("click");
        } else if ($('.recherche-pannel-item-popup-content-location', ctn).length !== 0) {
            btn.attr('data-cat-id', catId).attr('data-sub-cat', subCatHandle).attr('data-url', url);
            ctn.addClass('show');

            setTimeout(function () {
                $('.recherche-pannel-index-mot-label-input.location', ctn).focus();
            }, 300);
        } else {
            url += '?cat-id=' + catId;

            if (subCatHandle !== undefined) {
                url += '&sub-cat=' + subCatHandle;
            }

            window.location.href = url;
        }
    };

    var catScroll = function () {
        if (rechercheFiltreListItemOpen.length !== 0) {
            var target = rechercheFiltreListItemOpen.position().top;

            setTimeout(function () {
                rechercheContentFiltreListe.animate({scrollTop: target}, 1000);
            }, 500);
        }
    };

    var headerLinkClick = function () {
        var t = $(this);
        var parent = t.closest('.headerMenuItem');
        var subMenu = $('.headerSubmenu', parent);
        var header = t.closest('.site-header');

        if (subMenu.length !== 0) {
            if (parent.hasClass('open')) {
                subMenu.slideUp(300);
                parent.removeClass('open');
            } else {
                subMenu.slideDown(300);
                parent.addClass('open');
            }

            if (header.hasClass('menu-open')) {
                return false;
            }
        }
    };

    var regionUpdateClick = function () {
        var t = $(this);
        var val = t.attr('data-val');

        saveSessionVariable('region', val, function () {
            window.location.href = t.attr('href');
        });

        return false;
    };

    var locationUpdateClick = function () {
        var t = $(this);
        var val = t.attr('data-val');

        saveSessionVariable('location', val, function () {
            window.location.href = t.attr('href');
        });

        return false;
    };

    var onFocusTabBlock = function (e) {
        $(this).closest('.recherche-pannel-categorie-bottom').scrollLeft(0);
    };

    var chapterSelectChange = function () {
        var t = $(this);
        var ctn = t.closest('.chapitre-detail');
        var id = ctn.attr('data-id');

        if (t.val() !== '') {
            updateLabelLangs('chapter-select-' + id, t.val(), 'en,fr', function () {
                window.location.reload();
            });
        }
    };

    var chapterCapsuleBtnClick = function () {
        var t = $(this);
        var ctn = t.closest('.chapitre-detail-capsule-nb-items-ctn');
        var inputVal = $('.chapitre-detail-capsule-nb-items-form', ctn).val();
        var id = ctn.attr('data-id');

        updateLabelLangs('chapitre-detail-capsule-nb-items-' + id, inputVal, 'en,fr', function () {
            window.location.reload();
        });
    };

    var switchChange = function () {
        var isActive = $(this).is(':checked');
        var id = $(this).closest('.switch').data('id');

        updateLabelLangs('chapitre-detail-capsule-published-' + id, isActive, 'en,fr');
    };

	var updateContactArea = function() {
		contactArea = $(this).attr('data-extra');

		$('.contact-form-form-item-ctn.select.subject').slideDown();
	};

	var updateDirectEmail = function() {
		subject = $(this);

		// if ($('.directEmail').length > 0) {

		// 	$('.directEmail').val($(this).attr('data-email'));
		// }
	};
    
    win.load(function () {
        winWidth = win.width();
        winHeight = win.height();
        header = $('.site-header');
        toggleMenuBtn = $('.site-header-menu-toggle-btn', header);
        subNav = $('.site-nav-sub', header);
        subNavParent = subNav.parent('.site-nav-item');
        editableText = $('div[id^=displayTextInnerWindow]');
        contactFormBtn = $('.js-contact-form-send');
        dropdownCtn = $('.dropdown-select');
        dropdownBtn = $('.dropdown-select-btn', dropdownCtn);
        dropdownlist = $('.dropdown-select-pannel', dropdownCtn);
        dropdownlistItem = $('.dropdown-select-pannel-item', dropdownlist);
        contactInput = $('.contact-form-form-item-input');
        contactTextarea = $('.contact-form-form-item-textarea');
        aProposScrollerBtn = $('.a-propos-scroller-btn');
        aProposTerritoiresToggle = $('.a-propos-territoires-toggle');
        partenairesList = $('.partenaires-list');
        fontSizeBtn = $('.site-header-meta-font-size-btn');
        headerLink = $('.site-nav-main-link');

        btnRecherchePannel = $('.js-btn-recherche');
        recherchePannel = $('.recherche-side-pannel-content');
        mainContent = $('.main-content');

        newsListCtn = $('.js-news-list-ctn');

        recherchePannelForm = $('.recherche-pannel-form');
        recherchePannelFormInput = $('.recherche-pannel-input', recherchePannelForm);
        recherchePannelFormItem = $('.recherche-item-link', recherchePannelForm);
        recherchePannelRedirectBtn = $('.recherche-pannel-btn', recherchePannelForm);
        recherchePannelItemLink = $('.recherche-pannel-item-link');
        recherchePannelItemLinkPannel = $('.side-pannel .recherche-pannel-item-link');
        recherchePannelItemLinkHome = $('.index-recherche .recherche-pannel-item-link');
        recherchePannelItemPopup = $('.recherche-pannel-item-popup *');
        recherchePannelItemPopupClose = $('.recherche-pannel-item-popup-close-btn');
        recherchePannelSub = $('.btn-pannel-popup-btn');

        rechercheFiltreListItemOpen = $('.recherche-filtre-list-item.open');
        rechercheContentFiltreListe = $('.recherche-content-filtre-liste-inner');

        regionUpdate = $('.js-region-update');
        locationUpdate = $('.js-location-update');

        chapterSelect = $('.chapitre-detail-select');
        chapterCapsuleBtn = $('.chapitre-detail-capsule-nb-items-btn');

        if ($("#blogPost-postTime").length !== 0) {
            $("#blogPost-postTime").datepicker();
        }

        if ($("#blogPost-expireDate").length !== 0) {
            $("#blogPost-expireDate").datepicker();
        }

        checkMobile();
        initSlick();
        addEditableTextClass();
        addEditableTextPosition();
        moveEditableText();
        updateSubNavPosition();
        autoScreenHeight();
        addExternalLinkTarget();
        initSubNavMobile();
        initContactDD();
        aProposCheckScroll();
        togglePartenairesSlick();
        initFontSize();
        updateFSButtonState();
        initNewsScroll();
        dropdownDeleteDouble();
        //dropdownOrderList();
        catScroll();

        recherchePannel.each(function () {
            rechercheUpdateLink($(this));
        });

        $('.site-header-nav-item', subNavParent).click(menuSubNavParentClick);


        toggleMenuBtn.click(onClickMenuToggle);
        contactFormBtn.click(sendContactFormEmailClass);
        dropdownBtn.add(dropdownlistItem).click(toggleContactDD);
        dropdownlistItem.click(dropdownUpdateValue);
        aProposScrollerBtn.click(aProposScrollTo);
        aProposTerritoiresToggle.click(aProposTerritoiresToggleClick);
        fontSizeBtn.click(setFont);
        btnRecherchePannel.click(toggleRecherchePannel);
        recherchePannelFormItem.click(rechercheFiltreClick);
        recherchePannelRedirectBtn.click(recherchePannelRedirect);
        recherchePannelItemLink.click(recherchePannelItemLinkClick);
        recherchePannelItemLinkPannel.click(recherchePannelItemLinkPannelClick);
        recherchePannelItemPopupClose.click(recherchePannelItemPopupCloseClick);
        recherchePannelItemLinkHome.click(recherchePannelItemLinkHomeClick);
        headerLink.click(headerLinkClick);
        $('.js-contact-region-item').click(updateContactArea);
		$('.js-contact-subject-item').click(updateDirectEmail);
        //regionUpdate.click(regionUpdateClick);
        //locationUpdate.click(locationUpdateClick);
        chapterCapsuleBtn.click(chapterCapsuleBtnClick);
        recherchePannelSub.click(recherchePannelSubClick);

        recherchePannelFormInput.change(rechercheInputCPannelhange);
        recherchePannelItemPopup.focus(onFocusTabBlock);
        chapterSelect.change(chapterSelectChange);
        $('.switch input').change(switchChange);

        contactInput.add(contactTextarea).focus(formFieldFocus);
        contactInput.add(contactTextarea).blur(formFieldBlur);

        $(document).keydown(function (e) {
            var ch = (typeof e.which == "number") ? e.which : e.keyCode;

            if (ch === 13 || ch === 10) {
                if ($('.recherche-pannel-item-popup-content-location .recherche-pannel-index-mot-label-input.location:focus').length === 0) {
                    recherchePannelRedirectInput(ch);
                }
            } else {
                recherchePannelRedirectInput(ch);
            }
        });

        win.scroll(function () {
            aProposCheckScroll();
        });

        win.resize(function () {
            if (win.width() != winWidth) {
                winHeight = win.height();
                winWidth = win.width();

                checkMobile();
                updateSubNavPosition();
                initSubNavMobile();
                autoScreenHeight();

                if ($('body').hasClass('recherche-open')) {
                    checkPannelPos();
                }
            }
        });

        $('.tmpl-text-image-orientation').change(function () {
            var t = $(this);
            var ctn = t.closest('.tmpl-text-admin');
            var id = ctn.attr('data-id');

            updateLabelLangs(id, $('input:checked', ctn).val(), $('html').attr('lang'), function (){}, true);
        });
    });
    
})(jQuery);

/* GLOBAL */

var defaultDiacriticsRemovalMap = [
    {'base': 'A', 'letters': '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
    {'base': 'AA', 'letters': '\uA732'},
    {'base': 'AE', 'letters': '\u00C6\u01FC\u01E2'},
    {'base': 'AO', 'letters': '\uA734'},
    {'base': 'AU', 'letters': '\uA736'},
    {'base': 'AV', 'letters': '\uA738\uA73A'},
    {'base': 'AY', 'letters': '\uA73C'},
    {'base': 'B', 'letters': '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
    {'base': 'C', 'letters': '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
    {'base': 'D', 'letters': '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\u00D0'},
    {'base': 'DZ', 'letters': '\u01F1\u01C4'},
    {'base': 'Dz', 'letters': '\u01F2\u01C5'},
    {'base': 'E', 'letters': '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
    {'base': 'F', 'letters': '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
    {'base': 'G', 'letters': '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
    {'base': 'H', 'letters': '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
    {'base': 'I', 'letters': '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
    {'base': 'J', 'letters': '\u004A\u24BF\uFF2A\u0134\u0248'},
    {'base': 'K', 'letters': '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
    {'base': 'L', 'letters': '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
    {'base': 'LJ', 'letters': '\u01C7'},
    {'base': 'Lj', 'letters': '\u01C8'},
    {'base': 'M', 'letters': '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
    {'base': 'N', 'letters': '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
    {'base': 'NJ', 'letters': '\u01CA'},
    {'base': 'Nj', 'letters': '\u01CB'},
    {'base': 'O', 'letters': '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
    {'base': 'OI', 'letters': '\u01A2'},
    {'base': 'OO', 'letters': '\uA74E'},
    {'base': 'OU', 'letters': '\u0222'},
    {'base': 'OE', 'letters': '\u008C\u0152'},
    {'base': 'oe', 'letters': '\u009C\u0153'},
    {'base': 'P', 'letters': '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
    {'base': 'Q', 'letters': '\u0051\u24C6\uFF31\uA756\uA758\u024A'},
    {'base': 'R', 'letters': '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
    {'base': 'S', 'letters': '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
    {'base': 'T', 'letters': '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
    {'base': 'TZ', 'letters': '\uA728'},
    {'base': 'U', 'letters': '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
    {'base': 'V', 'letters': '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
    {'base': 'VY', 'letters': '\uA760'},
    {'base': 'W', 'letters': '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
    {'base': 'X', 'letters': '\u0058\u24CD\uFF38\u1E8A\u1E8C'},
    {'base': 'Y', 'letters': '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
    {'base': 'Z', 'letters': '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
    {'base': 'a', 'letters': '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
    {'base': 'aa', 'letters': '\uA733'},
    {'base': 'ae', 'letters': '\u00E6\u01FD\u01E3'},
    {'base': 'ao', 'letters': '\uA735'},
    {'base': 'au', 'letters': '\uA737'},
    {'base': 'av', 'letters': '\uA739\uA73B'},
    {'base': 'ay', 'letters': '\uA73D'},
    {'base': 'b', 'letters': '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
    {'base': 'c', 'letters': '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
    {'base': 'd', 'letters': '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
    {'base': 'dz', 'letters': '\u01F3\u01C6'},
    {'base': 'e', 'letters': '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
    {'base': 'f', 'letters': '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
    {'base': 'g', 'letters': '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
    {'base': 'h', 'letters': '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
    {'base': 'hv', 'letters': '\u0195'},
    {'base': 'i', 'letters': '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
    {'base': 'j', 'letters': '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
    {'base': 'k', 'letters': '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
    {'base': 'l', 'letters': '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
    {'base': 'lj', 'letters': '\u01C9'},
    {'base': 'm', 'letters': '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
    {'base': 'n', 'letters': '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
    {'base': 'nj', 'letters': '\u01CC'},
    {'base': 'o', 'letters': '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
    {'base': 'oi', 'letters': '\u01A3'},
    {'base': 'ou', 'letters': '\u0223'},
    {'base': 'oo', 'letters': '\uA74F'},
    {'base': 'p', 'letters': '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
    {'base': 'q', 'letters': '\u0071\u24E0\uFF51\u024B\uA757\uA759'},
    {'base': 'r', 'letters': '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
    {'base': 's', 'letters': '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
    {'base': 't', 'letters': '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
    {'base': 'tz', 'letters': '\uA729'},
    {'base': 'u', 'letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
    {'base': 'v', 'letters': '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
    {'base': 'vy', 'letters': '\uA761'},
    {'base': 'w', 'letters': '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
    {'base': 'x', 'letters': '\u0078\u24E7\uFF58\u1E8B\u1E8D'},
    {'base': 'y', 'letters': '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
    {'base': 'z', 'letters': '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
];

var diacriticsMap = {};

for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    var letters = defaultDiacriticsRemovalMap [i].letters;
    for (var j = 0; j < letters.length; j++) {
        diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap [i].base;
    }
}

function removeDiacritics(str) {
   return str;
    
}

function encodeText(name) {
    return name
        .replace(/\\xE0/g, '\xE0')
        .replace(/\\xE2/g, '\xE2')
        .replace(/\\xE3/g, '\xE3')
        .replace(/\\xE4/g, '\xE4')
        .replace(/\\xE5/g, '\xE5')
        .replace(/\\xE9/g, '\xE9')
        .replace(/\\xE8/g, '\xE8')
        .replace(/\\xEA/g, '\xEA')
        .replace(/\\xEB/g, '\xEB')
        .replace(/\\xEE/g, '\xEE')
        .replace(/\\xEF/g, '\xEF')
        .replace(/\\xF1/g, '\xF1')
        .replace(/\\xF2/g, '\xF2')
        .replace(/\\xF3/g, '\xF3')
        .replace(/\\xF4/g, '\xF4')
        .replace(/\\xF6/g, '\xF6')
        .replace(/\\xF9/g, '\xF9')
        .replace(/\\xFB/g, '\xFB')
        .replace(/\\xE7/g, '\xE7')
        .replace(/\\xC0/g, '\xC0')
        .replace(/\\xC7/g, '\xC7')
        .replace(/\\xC8/g, '\xC8')
        .replace(/\\xC9/g, '\xC9')
        .replace(/\\xCA/g, '\xCA')
        .replace(/\\xCE/g, '\xCE')
        .replace(/\\xCF/g, '\xCF')
        .replace(/\\xD1/g, '\xD1')
        .replace(/\\xD4/g, '\xD4');
}

function decodeText(name) {
    return name
        .replace(/\\xE0/g, 'à')
        .replace(/\\xE2/g, 'â')
        .replace(/\\xE8/g, 'è')
        .replace(/\\xE9/g, 'é')
        .replace(/\\xEA/g, 'ê')
        .replace(/\\xEB/g, 'ë')
        .replace(/\\xEE/g, 'î')
        .replace(/\\xEF/g, 'ï')
        .replace(/\\xE7/g, 'ç')
        .replace(/\\xFB/g, 'û')
        .replace(/\\xF4/g, 'ô')
        .replace(/\\xC0/g, 'À')
        .replace(/\\xC2/g, 'Â')
        .replace(/\\xC8/g, 'È')
        .replace(/\\xC9/g, 'É')
        .replace(/\\xCB/g, 'Ë')
        .replace(/\\xCE/g, 'Î')
        .replace(/\\xCF/g, '?')
        .replace(/\\xC7/g, 'Ç')
        .replace(/\\xD4/g, 'Ô');
}

function toggleContactDD() {
    var t = $(this);

    var ctn = t.closest('.dropdown-select');
    var allCtn = $('.dropdown-select');
    var list = $('.dropdown-select-pannel', ctn);
    var allList = $('.dropdown-select-pannel');

    if (ctn.hasClass('show-list')) {
        allCtn.removeClass('show-list');
        allList.slideUp(300);
    } else {
        ctn.addClass('show-list');
        list.slideDown(300);
    }
}

function dropdownUpdateValue(e, th) {
    var t = (th !== undefined) ? th : $(this);
    t.addClass('selecting');

    var val = t.find("span").html();
    var ctn = t.closest('.dropdown-select');
    var pos = t.attr("data-pos");
    $('.dropdown-select-input', ctn).val(val);
    if (t.attr('data-extra')) {
        $('.dropdown-select-input', ctn).attr('data-extra', t.attr('data-extra'));
    }
    $('.dropdown-select-btn-value', ctn).html(val);

    if (t.hasClass('js-contact-subject-item')) {
        if ($(".show-on-" + pos).length !== 0) {
            $(".show-on-" + pos).slideDown();
            $(".show-on-" + pos).addClass("showing");
        } else {
            $(".show-on-select").slideUp();
            $(".show-on-select").removeClass("showing");
        }
    }
    ctn.addClass('has-char');

    $('.dropdown-select-pannel-item.selected', ctn).removeAttr('style');
    $('.dropdown-select-pannel-item', ctn).removeClass('selected');
    t.addClass('selected').removeClass('selecting');
}